import React, { useContext, useEffect, useState } from 'react';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { RegioniContext, RegioniProvider } from './RegioniContext';
import { RegioniList } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        navigateTo
    } = useContext(NavContext);

    const {

        state,
        setState,

        isLoadingRegioni,
        getRegioniAsync,

        isDeletingRegione,
        deleteRegioneAsync,

    } = useContext(RegioniContext)

    const {
        deleteRegione
    } = state;

    const loadMoreHandler = async (pageIndex, pageSize, searchText, validFilter) => {
        await getRegioniAsync(pageIndex, pageSize, searchText, validFilter);
    };

    const [searchText, setSearchText] = useState("");
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const regioniListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.RegioneAdd, "_blank").focus();
                break;
            case "Delete":
                await deleteRegioneAsync(data.id);
                break;
            default:
                break;
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingRegioni || isDeletingRegione);
    }, [isLoadingRegioni, isDeletingRegione]);

    useEffect(() => {
        if (user) {
            if (deleteRegione)
                deleteRegioneAsync(deleteRegione.id);
            // setOpenDeleteRegioneDialog(true);
        }
    }, [deleteRegione, user])

    useEffect(() => {
        if (user)
            addBreadcrumbToken("Regioni");
    }, [user]);

    const [openDeleteRegioneDialog, setOpenDeleteRegioneDialog] = useState(false);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            search
                            onSearchClick={searchClickHandler}
                            title="Regioni"
                            subtitle="Gestisci le regioni" />
                    </Grid>
                    <Grid item xs={12}>
                        <RegioniList
                            searchText={searchText}
                            itemsPerPage={25}
                            onLoadMore={loadMoreHandler}
                            disabled={isLoading}
                            onActionClick={regioniListActionClickHandler} />
                    </Grid>
                </Grid>
            </Container>
            {/* <ActionDialog
                title="Disabilitazione regione"
                content={`Sei sicuro di disabilitare: "${deleteRegione?.descrizione}"`}
                open={openDeleteRegioneDialog}
                handleClose={() => {
                    setOpenDeleteRegioneDialog(false);
                    setState({ deleteRegione: null });
                }}
                handleSubmit={() => {
                    deleteRegioneAsync(deleteRegione.id);
                    setOpenDeleteRegioneDialog(false);
                    setState({ deleteRegione: null });
                }}
            /> */}
        </>
    );
}

export const RegioniPage = () => {

    return (
        <RegioniProvider>
            <PageContent />
        </RegioniProvider>
    );
}